import * as React from 'react';
import {HttpService} from './service';
import {HttpWrapperOptions} from './options';
import View from './view';
import {useSelector} from 'react-redux';
import {AppState} from '../../redux';
import {LoaderState} from '../../redux/reducers/loader';

export const HttpWrapper = () => {
  const blockingCallCount = useSelector<AppState, number>((state) => state.httpWrapper.blockingCallCount);
  const {loaderText, showLoader} = useSelector<AppState, LoaderState>((state) => state.loader);

  React.useEffect(() => {
    return httpService.cleanup;
  }, []);

  return View({
    loaderText,
    showLoader,
    blockingCallCount,
  });
};

const httpService = new HttpService();

export {httpService, HttpWrapperOptions};
